import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { class: "overflow-hidden" }
const _hoisted_3 = {
  class: "bg-white position-relative overflow-auto mw-100 pb-5",
  style: {"max-height":"650px"}
}
const _hoisted_4 = { class: "table table-bordered" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-top bg-white" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "position-relative border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Наименование ТМЦ "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " № потребности ТМЦ "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Дата поступления на закуп "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " № протокола выбора поставщика "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Дата отправки Протокола на согласование "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Дата согласования Протокола выбора поставщика "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Поставщик"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Дата оплаты "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Накладная ТМЦ "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Приход ТМЦ ")
  ])
], -1)
const _hoisted_6 = { class: "p-2" }
const _hoisted_7 = { class: "p-2" }
const _hoisted_8 = { class: "p-2" }
const _hoisted_9 = { class: "p-2" }
const _hoisted_10 = { class: "p-2" }
const _hoisted_11 = { class: "p-2" }
const _hoisted_12 = { class: "p-2" }
const _hoisted_13 = { class: "p-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "p-2" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "p-2" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "10",
  class: "p-2 text-center"
}, "Записи отсутствуют", -1)
const _hoisted_18 = [
  _hoisted_17
]

import api from "@/api";
import { reactive } from "vue";
import formatDate from "@/utils/formatDate";

type consolidatedReportOnMaterialMovementType = {
    id: number;
    documentNumber: string;
    materialName: string;
    requestedAt: string;
    protocolNumber?: string;
    protocolSentForApprovalAt?: string;
    protocolAgreedAt?: string;
    supplierName?: string;
    paidAt?: string;
};

type reportStateType = {
    materials: consolidatedReportOnMaterialMovementType[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ConsolidatedReportOnMaterialMovementComponent',
  setup(__props) {


const state: reportStateType = reactive({
    materials: [],
});

api.advancePayment.consolidatedReportOnMaterialMovement().then(({ data }) => {
    state.materials = data;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (state.materials.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.materials, (requiredMaterial) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: requiredMaterial.id
                  }, [
                    _createElementVNode("td", _hoisted_6, _toDisplayString(requiredMaterial.materialName), 1),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(requiredMaterial.documentNumber), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(requiredMaterial.requestedAt
                                            ? _unref(formatDate)(requiredMaterial.requestedAt)
                                            : ''), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(requiredMaterial.protocolNumber), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(requiredMaterial.protocolSentForApprovalAt
                                            ? _unref(formatDate)(requiredMaterial.protocolSentForApprovalAt)
                                            : ''), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(requiredMaterial.protocolAgreedAt
                                            ? _unref(formatDate)(requiredMaterial.protocolAgreedAt)
                                            : ''), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(requiredMaterial.supplierName), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(requiredMaterial.paidAt
                                            ? _unref(formatDate)(requiredMaterial.paidAt)
                                            : ''), 1),
                    _hoisted_14,
                    _hoisted_15
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("tr", _hoisted_16, _hoisted_18))
          ])
        ])
      ])
    ])
  ]))
}
}

})